module.exports = __webpack_public_path__ + "static/media/arcade_machine2.463bc2cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images/arcade_machine2.jpg
// module id = 680
// module chunks = 0